import React from 'react'

export default function OnChangeVista () {
    return (
        <div></div>
    )
}